import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import "../styles/SocialProject.scss";
import "./../styles/ComplaintReport.scss";
import Api from "../common/api";

const SocialProjectList = (id) => {
  const [datas, setData] = useState([]);
  const [activeYear, setYear] = useState(-1);
  const lang = localStorage.getItem("lang");

  let size = 3;
  if(lang == "en"){
    size = 4;
  }

  //setYear(-1);

  React.useEffect(() => {
    Api.get("/News/list/"+id.id).then((res) => {
        console.log(res.data);
        console.log(1900 + new Date(res.data.items[0].Created_date.split("(")[1].split(")")[0] * 1).getYear())
        setData(res.data.items);
    });
  }, []);

  return (
    <>
    
      <div className="full-width">
  
        <>
            <h3 style={{marginLeft: "-10px"}}>{lang == "en" ? "Our Works" : "Çalışmalarımız"}</h3>
            <div className="top-year-section hide">
                <ul className="row">
                    <li className={
                      activeYear == -1 ? "years active" : "years"
                    } style={{marginLeft: "0px"}} onClick={() => setYear(-1)}>{lang == "en" ? "All" : "Tümü"}</li>
                    <li className={
                      activeYear == 2025 ? "years active" : "years"
                    } style={{marginLeft: "0px"}} onClick={() => setYear(2025)}>2025</li>
                    <li className={
                      activeYear == 2024 ? "years active" : "years"
                    } style={{marginLeft: "0px"}} onClick={() => setYear(2024)}>2024</li>
                    <li className={
                      activeYear == 2023 ? "years active" : "years"
                    } style={{marginLeft: "0px"}} onClick={() => setYear(2023)}>2023</li>
                    <li className={
                      activeYear == 2022 ? "years active" : "years"
                    } style={{marginLeft: "0px"}} onClick={() => setYear(2022)}>2022</li>
                    <li className={
                      activeYear == 2021 ? "years active" : "years"
                    } style={{marginLeft: "0px"}} onClick={() => setYear(2021)}>2021</li>
                </ul>
            </div>
            {datas.map((data) => (
                activeYear == -1 || activeYear == (1900 + new Date(data.Created_date.split("(")[1].split(")")[0] * 1).getYear()) ? (
                    <div key={data.id} className="new-container news-list">
                        <div className="new-img-box">
                            {data.Image ? (
                                <img src={"https://sankoenerji.com.tr" + data.Image} alt="" />
                            ) : null}
                        </div>
                        <div className="new-content-box">
                            <h5>{data.Created_date ? new Date(data.Created_date.split("(")[1].split(")")[0] * 1).toLocaleDateString("tr-TR")
                                : null}
                            </h5>
                            <h4>{lang == "en" ? data.Title_EN : data.Title}</h4>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: lang == "en" ? data.Spot_EN : data.Spot,
                                }}
                            ></p>
                        </div>
                        {lang =="en" ? (
                        <button style={{ textDecoration: "none", color: "black" }}>
                            <a href={"/en/sustainability/Our-Social-Responsibility-Projects/" + data.Slug_EN}>
                                read more
                            </a>
                        </button>
                        ):(
                        <button style={{ textDecoration: "none", color: "black" }}>
                            <a href={"/surdurulebilirlik/sosyal-sorumluluk-projelerimiz/" + data.Slug}>
                                Haberin devamı için tıklayın
                            </a>
                        </button>
                        )}
                    </div>
                ) : ""
            )
            )}
        </>
      </div>      
    </>
  );
};
export default SocialProjectList;
